<template>
  <el-table :data="DetailData" stripe>
    <template v-for="(item, index) in productState.orderGoodsData">
      <el-table-column
        :align="item.align"
        :prop="item.prop"
        :label="item.label"
        :class-name="item.classname"
        :key="index"
        v-if="!(screen_value[0] === 3 && item.prop === 'price')"
      >
      </el-table-column>
    </template>

    <template slot="empty">
      <div class="img-no" v-if="showDefault">
        <img
          class="img-no-data"
          src="../../../assets/images/img_table_no_data.png"
        />
        <div class="noCart">暂无数据</div>
      </div>
    </template>
  </el-table>
</template>
<script>
import { useProduct } from '../hook/useProduct';
export default {
  name: 'table-detail',
  props: {
    DetailData: {
      type: Array,
      default: () => [],
    },
    screen_value: {
      type: Array,
      default: () => [],
    },
    showDefault: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    const { productState } = useProduct();
    this.productState = productState;
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.data-table {
  margin-top: 28px;
  border: 1px solid #d9d9d9;
  overflow: hidden;
  border-radius: 3px;
  ::v-deep .el-table tr:last-child td {
    border-bottom: none;
  }
  ::v-deep .el-table::before {
    background: transparent;
  }
  ::v-deep .el-table th {
    background: #fafafa;
    //line-height: 29px;
  }
  ::v-deep .el-table td {
    line-height: 29px;
    padding: 7px 0 6px;
  }
  .img-no {
    margin: 20px auto 10px auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .img-no-data-word {
      // margin: 10px auto;
    }
  }
}
</style>
